export const ReturnButton = {
  backgroundColor: "#fd703f",
  borderRadius: "5px",
  width: "200px",
  height: "30px",
  boxShadow: "none",
  padding: 0,
  border: "none",
  color: "white",
  cursor: "pointer",
};

export const ButtonWrapper = {
  width: "500px",
};

export const FallbackContainer = {
  width: "100%",
  height: "100%",
  paddingTop: "15%",
};

export const TextContainer = { width: "500px" };

export const IconStyle = { left: -30 };
